<template>
  <v-layout
    class="add-new-account"
    row
    justify-center>
    <v-dialog
      v-model="mpDialog.show"
      persistent
      scrollable
      max-width="600px">
      <v-card>
        <v-card-title v-if="mpDialog.type === 'new'">Create New Master Payer Account</v-card-title>
        <v-tabs v-model="currentTab">
          <v-tab v-for="item in tabItems" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>
 
        <v-card-text>
          <v-container>
            <v-tabs-items v-model="currentTab">
            <v-tab-item v-for="item in tabItems" :key="item">
            <v-form v-if="currentTab == 0" 
              ref="generalForm"
              v-model="valid"
              lazy-validation>
              <v-alert
                v-model="mpDialog.showResponse"
                :dismissible="true"
                :type="mpDialog.responseType"
                class="mb-3"
              >
                {{ mpDialog.responseMessage }}
              </v-alert>
              <div style="font-weight:500; font-size:14px">
                NOTE: All fields with
                <span style="color:red">*</span> are required
              </div>
              <v-text-field
                v-validate="'required'"
                v-model="mpDialog.fields.MP_ID"
                :disabled="isRecordView"
                :error="mpDialog.mpIdValidation.error"
                :error-messages="mpDialog.mpIdValidation.errorMessage || errors.collect('mpDialog.fields.MP_ID')"
                :success="mpDialog.mpIdValidation.success"
                :success-messages="mpDialog.mpIdValidation.successMessage"
                required
                data-vv-name="mpDialog.fields.MP_ID"
                data-vv-validate-on="blur"
                @change="validateMpId"
                
              >
                <template slot="label">
                  <span v-html="`MP ID <span class='required'>*</span>`"/>
                </template>
              </v-text-field>
              <v-select
                :items="['AISPL', 'EDP', 'Legacy', 'Perspecta', 'PPA', 'SPP', 'SPP - EDF', 'SPP - FG', 'Customer owned']"
                :readonly="isRecordView"
                v-model="mpDialog.fields.Agreement"
                required>
                <template slot="label">
                  <span v-html="`Agreement <span class='required'>*</span>`"/>
                </template>
              </v-select>
              <v-select
                :items="['Enterprise','Business','Developer','Basic']"
                :readonly="isRecordView"
                v-model="mpDialog.fields.AWS_Support_Type"
                attach
                required
              >
                <template slot="label">
                  <span v-html="`AWS Support Type <span class='required'>*</span>`"/>
                </template>
              </v-select>
              <v-select
                :items="['Internal','Dedicated','External','Saas', 'Gold managed svc']",
                :readonly="isRecordView"
                v-model="mpDialog.fields.Type"
                attach
              >
                <template slot="label">
                  <span v-html="`Type <span class='required'>*</span>`"/>
                </template>
              </v-select>
              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.MP_discount"
                required>
                <template slot="label">
                  <span v-html="`MP Discount`"/>
                </template>
              </v-text-field>
              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.MP_uplift"
                required>
                <template slot="label">
                  <span v-html="`MP Uplift`"/>
                </template>
              </v-text-field>
              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.MP_Business_Rules"
                required>
                <template slot="label">
                  <span v-html="`Account Name <span class='required'>*</span>`"/>
                </template>
              </v-text-field>
              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.MP_features"
                required>
                <template slot="label">
                  <span v-html="`MP Features`"/>
                </template>
              </v-text-field>
              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.MP_Type"
                required>
                <template slot="label">
                  <span v-html="`MP Type`"/>
                </template>
              </v-text-field>
              <v-select
                attach
                :items="['Yes', 'No']"
                :readonly="isRecordView"
                label="Grandfathered"
                v-model="mpDialog.fields.Grandfathered"
              ></v-select>
              <v-select
                attach
                :items="['Yes', 'No']"
                :readonly="isRecordView"
                label="Control Tower Log Usage"
                v-model="mpDialog.fields.CT_Log_Usage"
              ></v-select>
            </v-form>
            <!-- Sync Config Tab -->
            <v-form v-else-if="currentTab == 1" 
              ref="generalForm"
              v-model="valid"
              lazy-validation>
         
              <v-autocomplete
                v-model="selectedCustomer"
                :items="newAwsAcctExistingClient.customers"
                :item-text="(item) => `${item.Cust_Region}`"
                :readonly="isRecordView"
                item-value="Customer_Id"
                label="Customer Name"
              />

              
              <!-- <v-text-field
                v-model="mpDialog.fields.Sync_Config.Managed_Services"
                required>
                <template slot="label">
                  <span v-html="`Managed Service`"/>
                </template>
              </v-text-field> -->

              <v-select
                required
                v-model="mpDialog.fields.Sync_Config.Managed_Services"
                :items="['DXC Gold','DXC Silver','AMS (AWS Managed Services)','None']"
                :readonly="isRecordView"
                attach
                label="Managed SVC"
              />

              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.Sync_Config.WBS_code"
                label="WBS Code"
                required />

              <v-text-field
                 :readonly="isRecordView"
                v-model="mpDialog.fields.Sync_Config.IWO_code"
                required
                label="IWO Code" />

            </v-form>
            </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <v-tabs-items v-model="currentTab">
            <v-tab-item v-for="item in tabItems" :key="item">
            
            <v-card-actions v-if="currentTab == 0">
            <v-btn @click.stop="onCancel">Close</v-btn>
            <v-btn
              v-if="$can('write', 'master-payer') && !isRecordView"
              :loading="mpDialog.saving"
              :disabled="!formComplete || errors.items.length > 0 || mpDialog.mpIdValidation.error === true"
              color="orange"
              @click="mpDialog.submitHandler(mpDialog.fields)"
            >{{ mpDialog.submitLabel }}</v-btn>
            </v-card-actions>

            <v-card-actions v-else-if="currentTab == 1">
            <v-btn @click.stop="onCancel">Close</v-btn>
            <v-btn
              v-if="$can('write', 'master-payer') && !isRecordView"
              :loading="mpDialog.saving"
              :disabled="!syncConfigComplete"
              color="orange"
              @click="mpDialog.submitHandler(mpDialog.fields)"
            >Update Sync Config</v-btn>
          </v-card-actions>

          </v-tab-item>
          </v-tabs-items>
        </v-card-actions>
      </v-card>

    </v-dialog>

  </v-layout>
</template>
<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      valid: true,
      step: 1,
      search: null,
      awsSuppType: ['Enterprise', 'Business', 'Developer', 'Basic'],
      type: ['Internal', 'Dedicated', 'External', 'Saas'],
      tabItems: ['MP', 'Sync Config'],
      currentTab: null
    }
  },
  mounted () {
    let type = 'existing'
    console.log('MASTERPAYER VIEW')
    this.$store.dispatch('user/requestAws/getCustomers', type)
  },
  computed: {
    ...mapState('admin', ['mpDialog']),
    ...mapState('user/requestAws', ['newAwsAcctExistingClient']),
    formComplete () {
      return (
        this.mpDialog.fields.MP_ID &&
        this.mpDialog.fields.Agreement &&
        this.mpDialog.fields.AWS_Support_Type &&
        this.mpDialog.fields.Type &&
        this.mpDialog.fields.MP_discount &&
        this.mpDialog.fields.MP_uplift &&
        this.mpDialog.fields.MP_Business_Rules &&
        this.mpDialog.fields.MP_features &&
        this.mpDialog.fields.MP_Type
      )
    },
    selectedCustomer: {
      get() {
        debugger
        const syncConfigCustId = this.mpDialog.fields.Sync_Config.Customer_Id
        const selectedCustomer = this.newAwsAcctExistingClient.customers.find(customer => customer.Customer_Id == syncConfigCustId);
        return selectedCustomer ? selectedCustomer.Customer_Id : ""
      },
      set(value){
        debugger
        this.mpDialog.fields.Sync_Config.Customer_Id = Number(value);
      }
    },
    syncConfigComplete() { 
      return (
        this.mpDialog.fields.Sync_Config.Customer_Id &&
        this.mpDialog.fields.Sync_Config.Managed_Services &&
        this.mpDialog.fields.Sync_Config.WBS_code &&
        this.mpDialog.fields.Sync_Config.IWO_code
      )
    },
    isRecordView() {
      return this.mpDialog.type === 'view'
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      validateMPId: 'admin/validateMasterPayerMPId'
    }),
    onCancel () {
      console.log('masterpayer cancel')
      this.$store.commit(
        'showDialog',
        {
          show: true,
          type: 'confirmation',
          persistent: true,
          title: 'Are you sure you to close this window?',
          yesLabel: 'Yes',
          yesHandler: () => {
            this.$store.commit('showDialog', { show: false })
            this.$store.commit('admin/resetMasterPayerDialog')
            this.$store.commit('admin/clearValidationErrors')
          },
          noHandler: () => {
            this.$store.commit('showDialog', { show: false })
          },
          noLabel: 'No'
        },
        { root: true }
      )
    },
    validateMpId () {
      let mpId = this.mpDialog.fields.MP_ID
      if (isNaN(mpId)) {
        console.log('is not a number')
        this.$store.commit('admin/setMpIdValidation', {
          error: true,
          success: false,
          errorMessage: 'MP_ID should be numeric'
        })
      } else {
        console.log('is a number')
        this.validateMPId(this.mpDialog.fields.MP_ID)
      }
    }
  }
}
</script>
<style lang="scss">
.add-new-account {
  .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
    > .v-input__control
    > .v-input__slot {
    background: #7e7e7e;
  }
}

.account-overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 5;
}
.required label::after {
  content: "*";
}
</style>
